import { render } from "./App.vue?vue&type=template&id=8d2d68f2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=8d2d68f2&lang=css"
script.render = render

export default script